<template>
  <v-container mt-10>
    <v-row mb-2>
      <v-col cols="12">
        <v-chip class="ma-2" :color="this.color" large>
          <span style="color: white; padding-right: 10px; font-size: 20px">
            Reporte: {{ this.RepInd }}</span>
          <div style="
              font-size: 16px;
              background-color: white;
              color: black;
              border-radius: 25px;
              padding: 6% 2% 6% 2%;
              font-weight: bold;
            ">
            {{ this.etiqueta }}
          </div>
        </v-chip>
      </v-col>
    </v-row>
    <v-card style="height: 50% !important; borde: none" id="DatosGenerales">
      <v-tabs v-model="tabs" centered>
        <v-tab @click="pushTo('detalles')"> Detalle General </v-tab>
        <v-tab @click="pushTo('Seguimiento')"> Seguimiento </v-tab>
        <v-tab v-if="validaflotilla == 1" @click="pushTo('documentosAUSA')">Confirmaci&oacute;n</v-tab>
        <v-tab @click="pushTo('documentosView')">
          Validaci&oacute;n Documentos
        </v-tab>
        <v-tab @click="pushTo('Archivos')"> Archivos </v-tab>
        <!-- <v-tab v-if="aiclave==26" @click="pushTo('Demeritos')"> Dem&eacute;ritos </v-tab> -->
        <!--<v-tab @click="pushTo('Confirmaciondocto')">
          Confirmaci�n de Documentos
        </v-tab>-->
      </v-tabs>
      <v-tabs-items class="container">
        <router-view></router-view>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Reporte from "@/services/GestoriaDoc/Reporte.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
  components: {},
  data: function () {
    return {
      nrreporte: "",
      svindice: "",
      aiclave: "",
      tabs: "",
      RepInd: "",
      svfhconclusion: "",
      svfhcerrado: "",
      color: "",
      etiqueta: "",
      aiclave: 0,
      validaflotilla: 0,
    };
  },

  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
  },
  async mounted() {
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.aiclave = datos.aiclave;
    Reporte.validarFlotilla(this, datos.nrreporte, datos.svindice).then(
      (response) => {
        this.validaflotilla = response;
      }
    );
  },
  updated() {
    this.getInitialData();
  },
  methods: {
    async getInitialData() {
      Reporte.EncabezadoReporte(this).then((response) => {
        this.RepInd = response.nrreportei;
        this.color = response.color;
        this.etiqueta = response.etiqueta;
      });
    },
    pushTo(param) {
      switch (param) {
        case "detalles":
          this.$router.push({ name: `ReporteDetalleGD` });
          break;
        case "documentos":
          this.$router.push({ name: `DocumentosGD` });
          break;
        case "Seguimiento":
          this.$router.push({ name: `ReporteSeguimientoGD` });
          break;
        case "documentosView":
          this.$router.push({ name: `DocumentosView` });
          break;
        case "Archivos":
          this.$router.push({ name: `Archivos` });
          break;
        case "Demeritos":
          this.$router.push({ name: `Demeritos` });
          break;
        case "documentosAUSA":
          this.$router.push({ name: `DoctosAusa` });
          break;
        case "Confirmaciondocto":
          this.$router.push({ name: `confirmadocto` });
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.v-card__text {
  align-content: center;
  padding-top: 10px !important;
}

#menu_reporte .v-toolbar__content {
  height: 0px !important;
}

#menu_reporte {
  height: 50% !important;
}

#custom-tab-items {
  background-color: transparent !important;
}

#DatosGenerales .v-toolbar__title {
  font-size: 24px;
}

#DatosGenerales .v-list-item__title {
  font-size: 18px;
  /*font-weight: bold;*/
}

#DatosGenerales span.font-weight-bold {
  font-size: 18px;
}

.container {
  max-width: 2536px !important;
}

.vs-list--title {
  font-size: 20px;
}

.vs-list--subtitle {
  font-size: 16px;
}

/* .mdi-check-circle-outline {
  color: #3cd4a0 !important;
} */
.mdi-checkbox-marked {
  color: #3cd4a0 !important;
}

.mdi-home,
.mdi-cellphone,
.mdi-briefcase {
  color: #3cd4a0 !important;
}

.mdi-file-document,
.mdi-car-info,
.mdi-card-account-phone,
.mdi-alert-octagon,
.mdi-doctor,
.mdi-folder-alert,
.mdi-badge-account-alert,
.mdi-text-box-multiple-outline,
.mdi-bank,
.mdi-school,
.mdi-archive,
.mdi-school-outline,
.mdi-badge-account-alert-outline,
.mdi-information-outline,
.mdi-map-marker-radius,
.mdi-account-supervisor,
.mdi-calendar,
.mdi-car,
.mdi-calendar-clock,
.mdi-email {
  color: white !important;
}

/* Por debajo de 400px */
@media screen and (max-width: 600px) {
  #DatosGenerales .v-list-item__title {
    font-size: 10px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 960px) {
  #DatosGenerales .v-list-item__title {
    font-size: 12px;
  }
}

@media only screen and (min-width: 960px) and (max-width: 1264px) {
  #DatosGenerales .v-list-item__title {
    font-size: 14px;
  }
}

@media only screen and (min-width: 1264px) and (max-width: 1904px) {
  #DatosGenerales .v-list-item__title {
    font-size: 16px;
  }
}

@media only screen and (min-width: 1904px) {
  #DatosGenerales .v-list-item__title {
    font-size: 18px;
  }
}

#DetalleReporte .vs-list--subtitle {
  font-size: 20px;
  font-weight: 700;
}

#DetalleReporte .vs-list--title {
  font-size: 12.8px;
  font-weight: 700;
}

#titulocard {
  color: white;
}</style>
